import { InformationEditPage } from "@/features/information/pages/InformationEdit";

const InformationEdit = () => {
  return <InformationEditPage />;
};

export default InformationEdit;
